import { Select, Table } from "antd";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import React from "react";
import { initReactI18next } from "react-i18next";
import * as de from "./de";
import * as en from "./en";
import * as it from "./it";
import * as zhCN from "./zh-CN";

// Sort All Translation keys Alphabetically.
const resources = {
  en,
  it,
  de,
  "zh-CN": zhCN
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    ns: [
      "userManagement",
      "auth",
      "sideNavigationMenu",
      "topNavigationMenu",
      "header",
      "home",
      "components",
      "production",
      "offlineStudy",
      "common",
      "changeAssessment",
      "auditLogs",
      "onDemandProtocol",
      "onDemandStudies",
      "settings",
      "userManagement",
      "variables",
      "defaultUnits",
      "documentConfiguration",
      "cleaningLimitPolicy",
      "approvalPolicy",
      "sampleLocationAssessment",
      "worstProductionSelection",
      "adminSettings",
      "masterData",
      "changePassword",
      "migrateProduction",
      "addEditProduction",
      "equipment",
      "apiMessages",
      "auditPortal",
      "components",
      "inspectionValidation"
    ],
    resources
  });

// Monkey-Patch Table and Select Component
Table.defaultProps = {
  ...Table.defaultProps,
  locale: {
    emptyText: i18n.t("dashboard:no-data-to-display")
  }
};

(Select as any).defaultProps = {
  ...Select.defaultProps,
  notFoundContent: (
    <div style={{ textAlign: "center" }}>{i18n.t("dashboard:no-data-to-display")}</div>
  )
};

export default i18n;
